import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { fetchUser } from '../Users/actions';

import {
  EXPORT_DATA,
  FILTER_DEFAULT_LIMIT,
  REQUEST_ADD_COMPANY_ADDRESS,
  REQUEST_COMPANIES,
  REQUEST_COMPANIES_CREATE,
  REQUEST_COMPANIES_SEARCH,
  REQUEST_COMPANY,
  REQUEST_HOME_COMPANY,
  SET_NEW_COMPANY_VALUE,
  REQUEST_COMPANY_ADD_USER,
  REQUEST_COMPANY_DELETE_USER_FROM_COMPANY,
  REQUEST_COMPANY_FILTER,
  UPDATE_COMPANY_FILTERS,
  APPLY_COMPANY_FILTER,
  REQUEST_COMPANY_FILTER_RESET,
  REQUEST_COMPANY_PROPERTY_UPDATE,
  REQUEST_COMPANY_SET_PARENT_COMPANY,
  REQUEST_COMPANY_SET_SUB_COMPANY,
  REQUEST_COUNTRIES,
  REQUEST_DELETE_COMPANY_ADDRESS,
  REQUEST_UPDATE_COMPANY_ADDRESS,
  INITIATE_COMPANY_CREATE,
  INITIATE_COMPANY_EDIT,
  SET_NEW_COMPANY_ADDRESS,
  SHOW_MAIN_FORM,
  HIDE_MAIN_FORM,
  SYNC_EXACT_ID,
  REQUEST_COMPANY_USERS,
  REQUEST_COMPANY_PROPERTY,
  REQUEST_IBAN_CHECK,
  REQUEST_VIES_CHECK,
  REQUEST_VIES_CHECK_HISTORY,
  REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT,
  TOGGLE_NOTIFICATION,
  COMPANY_DUN,
  REQUEST_COMPANY_WORKFLOWS,
  REQUEST_ADD_COMPANY_WORKFLOW,
  REQUEST_REMOVE_COMPANY_WORKFLOW,
  ADD_COMPANY_TO_BULK_ACTIONS_LIST,
  REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST,
  REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST,
  SHARE_EXCEL_COMPANY_DATA,
  REQUEST_COMPANIES_PROPERTY,
  REQUEST_COMPANIES_BY_IDS,
  UPDATE_COMPANY_SEARCH_STRING,
  APPLY_COMPANY_SORT_ORDER,
  REQUEST_COMPANY_HISTORY,
  UPDATE_COMPANY_HISTORY_FILTER,
  UPDATE_COMPANY_HISTORY_SEARCH_STRING,
  REQUEST_COMPANY_PROPERTY_NAMES,
  REQUEST_DUPLICATE_VAT_COMPANY,
  REQUEST_COMPANY_AVATAR_UPDATE,
} from './constants';

export function fetchCompanies(offset = 0, limit = FILTER_DEFAULT_LIMIT, callback) {
  return {
    type: REQUEST_COMPANY_FILTER,
  };
}

export function applyCompanyFilter() {
  return {
    type: APPLY_COMPANY_FILTER,
  };
}

export function changeCompanyFilter(name, value) {
  return {
    type: REQUEST_COMPANY_FILTER,
    name,
    value,
  };
}

export function changeCompanySortOrder(sortType, order) {
  return {
    type: APPLY_COMPANY_SORT_ORDER,
    sortType,
    order,
  };
}

export function updateCompanySearchString(value) {
  return {
    type: UPDATE_COMPANY_SEARCH_STRING,
    text: value,
  };
}

export function resetCompanyFilter() {
  return {
    type: REQUEST_COMPANY_FILTER_RESET,
  };
}

export function updateCompanyFilter(propertyFilter, options) {
  return {
    type: UPDATE_COMPANY_FILTERS,
    propertyFilter,
    ...options,
  };
}

export function changeCompanyPropertyFilter(propertyFilter, options) {
  return {
    type: REQUEST_COMPANY_FILTER,
    propertyFilter,
    ...options,
  };
}

export function fetchCompanyPropertyNames() {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_PROPERTY_NAMES,
    work: REQUEST_COMPANY_PROPERTY_NAMES,
    path: `company/propertyNames`,
  };
}

export function fetchCompany(companyId, callback) {
  const id = companyId ? parseInt(companyId) : '';

  return {
    type: GET_MY,
    id: REQUEST_COMPANY,
    work: [REQUEST_COMPANY, `${REQUEST_COMPANY}-${id}`],
    callback,
    path: `company/${id}`,
  };
}

export function fetchDuplicateVatCompany(companyId, callback) {
  const id = companyId ? parseInt(companyId) : '';

  return {
    type: GET_MY,
    id: REQUEST_DUPLICATE_VAT_COMPANY,
    work: [REQUEST_DUPLICATE_VAT_COMPANY, `${REQUEST_DUPLICATE_VAT_COMPANY}-${id}`],
    callback,
    path: `company/${id}`,
  };
}

export function fetchCompaniesByIds(ids, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANIES_BY_IDS,
    work: [REQUEST_COMPANY, ...ids.map(id => `${REQUEST_COMPANY}-${id}`)],
    post: { ids },
    path: 'company/getListByIds',
    callback,
  };
}

export function fetchHomeCompany(callback) {
  return {
    type: GET_MY,
    id: REQUEST_HOME_COMPANY,
    work: REQUEST_HOME_COMPANY,
    callback,
    path: 'company/home-company',
  };
}

export function fetchCompanyProperty(companyId, propertyName, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_PROPERTY,
    companyId,
    propertyName,
    work: [REQUEST_COMPANY, `${REQUEST_COMPANY}-${companyId}`],
    gate: `${REQUEST_COMPANY}-${propertyName}-${companyId}`,
    callback,
    path: `company/${companyId}/properties/${propertyName}`,
  };
}

export function fetchCompaniesPropertyByIds(companiesIds, propertyName, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANIES_PROPERTY,
    work: REQUEST_COMPANIES_PROPERTY,
    gate: `${REQUEST_COMPANY}-${propertyName}-${companiesIds.join('_')}`,
    path: `company/properties/${propertyName}`,
    post: { ids: companiesIds },
    companiesIds,
    propertyName,
    callback,
  };
}

export function fetchCompanyUsers(companyId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_USERS,
    work: [REQUEST_COMPANY_USERS, `${REQUEST_COMPANY_USERS}-companyId`],
    path: `company/${companyId}/users`,
    callback,
  };
}

export function createCompany(properties, addresses, accountManagerId, options, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANIES_CREATE,
    gate: REQUEST_COMPANIES_CREATE,
    post: { properties, addresses: addresses || [], accountManagerId: accountManagerId || null, options },
    path: `company`,
    callback,
  };
}

export function setCompanyProperty(companyId, name, value, callback) {
  return {
    type: GET_MY,
    post: {
      companyId,
      name,
      value,
    },
    companyId,
    name,
    value,
    work: REQUEST_COMPANY_PROPERTY_UPDATE,
    gate: REQUEST_COMPANY_PROPERTY_UPDATE + companyId + name,
    callback,
    path: `company/${companyId}/property`,
    putOnComplete: [fetchCompany(companyId)],
  };
}

export function updateCompanyProperties(
  companyId,
  properties,
  addresses,
  accountManagerId,
  callback,
  skipVatUniquenessCheck = false,
) {
  return {
    type: GET_MY,
    patch: {
      properties,
      addresses,
      accountManagerId,
      skipVatUniquenessCheck,
    },
    companyId,
    work: REQUEST_COMPANY_PROPERTY_UPDATE,
    gate: REQUEST_COMPANY_PROPERTY_UPDATE + companyId,
    callback,
    path: `company/${companyId}`,
    putOnComplete: [fetchCompany(companyId)],
  };
}

export function saveFile(companyId, propertyName, file, callback) {
  return {
    type: GET_MY,
    post: {
      companyId,
      propertyName,
      file,
    },
    options: { formData: true },
    companyId,
    name,
    work: REQUEST_COMPANY_AVATAR_UPDATE,
    gate: REQUEST_COMPANY_AVATAR_UPDATE + companyId + name,
    callback,
    path: `company/${companyId}/property/file`,
    putOnComplete: [fetchCompany(companyId)],
  };
}

export function deleteCompanyProperty(propertyId, companyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY,
    gate: REQUEST_COMPANY_PROPERTY_UPDATE + companyId + name,
    delete: {},
    path: `company/${companyId}/property/${propertyId}`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function fetchCountries() {
  return {
    type: GET_MY,
    id: REQUEST_COUNTRIES,
    work: REQUEST_COUNTRIES,
    path: `countries`,
  };
}

export function addAddress(companyId, addressDto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_ADD_COMPANY_ADDRESS,
    gate: REQUEST_ADD_COMPANY_ADDRESS + companyId,
    post: addressDto,
    path: `company/${companyId}/address`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function updateAddress(companyId, addressId, addressDto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_UPDATE_COMPANY_ADDRESS,
    gate: REQUEST_UPDATE_COMPANY_ADDRESS + companyId + addressId,
    put: addressDto,
    path: `company/${companyId}/address/${addressId}`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function exportData(companyId, callback) {
  return {
    type: GET_MY,
    work: EXPORT_DATA,
    gate: EXPORT_DATA + companyId,
    post: companyId,
    path: `company/${companyId}/export`,
    callback,
  };
}

export function deleteAddress(companyId, addressId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_COMPANY_ADDRESS,
    gate: REQUEST_DELETE_COMPANY_ADDRESS + companyId + addressId,
    delete: {},
    path: `company/${companyId}/address/${addressId}`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function companySearch(text, callback) {
  let path = `company/getList`;

  const searchParams = {
    offset: 0,
    limit: 50,
    text,
    filters: [],
  };
  return {
    type: GET_MY,
    work: REQUEST_COMPANIES,
    gate: REQUEST_COMPANIES,
    path,
    post: searchParams,
    callback,
  };
}

export function addSubCompanyToCompany(companyId, subCompanyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_SET_SUB_COMPANY,
    gate: REQUEST_COMPANY_SET_SUB_COMPANY + companyId,
    post: { subCompanyId },
    path: `company/${companyId}/sub-company`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function addParentCompany(companyId, parentCompanyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_SET_PARENT_COMPANY,
    gate: REQUEST_COMPANY_SET_PARENT_COMPANY + companyId,
    post: { subCompanyId: companyId },
    path: `company/${parentCompanyId}/sub-company`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function deleteSubCompanyFromCompany(companyId, subCompanyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_SET_SUB_COMPANY,
    gate: REQUEST_COMPANY_SET_SUB_COMPANY + companyId,
    delete: { subCompanyId },
    path: `company/${companyId}/sub-company/${subCompanyId}`,
    putOnComplete: [fetchCompany(companyId)],
    callback,
  };
}

export function deleteParentCompanyFromCompany(companyId, parentCompanyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_SET_SUB_COMPANY,
    gate: REQUEST_COMPANY_SET_SUB_COMPANY + companyId,
    delete: { subCompanyId: companyId },
    path: `company/${companyId}/sub-company/${parentCompanyId}`,
    putOnComplete: [fetchCompany(parentCompanyId)],
    callback,
  };
}

export function deleteUserFromCompany(companyId, userId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_DELETE_USER_FROM_COMPANY,
    gate: REQUEST_COMPANY_DELETE_USER_FROM_COMPANY + companyId,
    delete: {},
    path: `company/${companyId}/user/${userId}`,
    putOnComplete: [fetchCompany(companyId), fetchUser(userId)],
    callback,
  };
}

export function addUserToCompany(companyId, userId, callback) {
  return {
    type: GET_MY,
    post: { userId },
    id: REQUEST_COMPANY_ADD_USER,
    work: REQUEST_COMPANY_ADD_USER,
    path: `company/${companyId}/user`,
    putOnComplete: [fetchCompany(companyId), fetchUser(userId)],
    callback,
  };
}

export function syncExactId(companyId) {
  return {
    type: GET_MY,
    post: {},
    id: SYNC_EXACT_ID,
    work: SYNC_EXACT_ID + companyId,
    path: `exact/export/sync/company/${companyId}`,
    putOnComplete: [fetchCompany(companyId)],
  };
}

export function setNewCompanyValue(name, value) {
  return {
    type: SET_NEW_COMPANY_VALUE,
    name,
    value,
  };
}

export function setNewCompanyAddress(address) {
  return {
    type: SET_NEW_COMPANY_ADDRESS,
    address,
  };
}

export function initiateNewCompnayValue(name) {
  return {
    type: SET_NEW_COMPANY_VALUE,
    name,
    initiate: true,
  };
}

export function initiateCompanyCreate() {
  return {
    type: INITIATE_COMPANY_CREATE,
  };
}

export function initiateCompanyEdit(id) {
  return {
    type: INITIATE_COMPANY_EDIT,
    id,
  };
}

export function showMainForm() {
  return {
    type: SHOW_MAIN_FORM,
  };
}

export function hideMainForm() {
  return {
    type: HIDE_MAIN_FORM,
  };
}

export function checkSignicatIban(companyId, name, iban) {
  return {
    type: GET_MY,
    id: REQUEST_IBAN_CHECK,
    work: `${REQUEST_IBAN_CHECK}-${companyId}`,
    gate: `${REQUEST_IBAN_CHECK}-${companyId}`,
    post: { name, iban },
    path: `signicat/iban-check`,
  };
}

export function checkRaboIban(companyId, name, iban) {
  return {
    type: GET_MY,
    id: REQUEST_IBAN_CHECK,
    work: `${REQUEST_IBAN_CHECK}-${companyId}`,
    gate: `${REQUEST_IBAN_CHECK}-${companyId}`,
    post: { name, iban },
    path: `rabo/iban-check`,
  };
}

export function checkIban(companyId, name, iban, provider = 'RABO') {
  const ibanCheckProvidersMap = {
    RABO: checkRaboIban,
    SIGNICAT: checkSignicatIban,
  };

  return ibanCheckProvidersMap[provider](companyId, name, iban);
}

export function checkVies(dto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_VIES_CHECK,
    id: REQUEST_VIES_CHECK,
    post: dto,
    path: `/vies`,
    callback,
  };
}

export function fetchCompanyViesChecksHistory(companyId, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_VIES_CHECK_HISTORY}-${companyId}`,
    path: `/entity-history/company/${companyId}`,
    callback,
  };
}

export function downloadViesCheckDocument(body, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT,
    gate: REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT,
    post: body ?? {},
    path: `/vies/pdf`,
    callback,
  };
}

export function toggleNotification(isShow, message) {
  return {
    type: TOGGLE_NOTIFICATION,
    isShow,
    message,
  };
}

export function getCompanyDunIdByName(companyId, countryCode, callback) {
  return {
    type: GET_MY,
    work: COMPANY_DUN,
    gate: COMPANY_DUN,
    companyId,
    post: {
      countryCode,
    },
    id: 'dunIdByName',
    path: `/dun/${companyId}/idByName`,
    callback,
  };
}

export function getCompanyWorkflows(companyId, callback) {
  console.log('ACTION companyId', companyId);
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_WORKFLOWS,
    work: REQUEST_COMPANY_WORKFLOWS,
    gate: REQUEST_COMPANY_WORKFLOWS,
    companyId,
    path: `/company-workflows/${companyId}/workflows`,
    callback,
  };
}

export function addWorkflowToCompany(companyId, workflowId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_COMPANY_WORKFLOW,
    work: REQUEST_ADD_COMPANY_WORKFLOW,
    gate: REQUEST_ADD_COMPANY_WORKFLOW,
    companyId,
    path: `/company-workflows/${companyId}/workflows`,
    post: { workflowId },
    putOnComplete: [getCompanyWorkflows(companyId)],
    callback,
  };
}

export function deleteWorkflowToCompany(companyId, workflowId) {
  return {
    type: GET_MY,
    id: REQUEST_REMOVE_COMPANY_WORKFLOW,
    work: REQUEST_REMOVE_COMPANY_WORKFLOW,
    gate: REQUEST_REMOVE_COMPANY_WORKFLOW,
    companyId,
    path: `/company-workflows/${companyId}/workflows/${workflowId}`,
    delete: {},
    putOnComplete: [getCompanyWorkflows(companyId)],
  };
}

export function addCompanyToBulkActionsList(company) {
  return {
    type: ADD_COMPANY_TO_BULK_ACTIONS_LIST,
    payload: company,
  };
}

export function removeCompanyFromBulkActionsList(companyId) {
  return {
    type: REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST,
    companyId,
  };
}

export function removeAllCompaniesFromBulkActionsList(callback) {
  return {
    type: REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST,
    callback,
  };
}

export function shareExcelCompanyData(dto, callback) {
  return {
    type: GET_MY,
    work: SHARE_EXCEL_COMPANY_DATA,
    gate: SHARE_EXCEL_COMPANY_DATA,
    post: dto,
    path: '/company/bulk-actions/export ',
    callback,
  };
}

export function fetchCompanyHistory(companyId, text = '', properties, callback) {
  let path = `/entity-history/company/${companyId}?offset=0&limit=9999&order=desc`;
  if (text) {
    path += `&text=${text}`;
  }
  if (properties?.length) {
    properties?.forEach(p => {
      return (path += `&fields=${p?.value}`);
    });
  }
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_HISTORY,
    work: REQUEST_COMPANY_HISTORY,
    gate: REQUEST_COMPANY_HISTORY + companyId,
    path: path,
    callback,
  };
}

export function updateCompanyHistoryFilter(properties = []) {
  return {
    type: UPDATE_COMPANY_HISTORY_FILTER,
    properties,
  };
}

export function updateCompanyHistorySearchString(text) {
  return {
    type: UPDATE_COMPANY_HISTORY_SEARCH_STRING,
    text,
  };
}
